import React, { useState } from 'react';
import { ChevronDownIcon, StethoscopeIcon, ClipboardListIcon, PhoneIcon, CalendarIcon, ShieldCheckIcon, MapPinIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'What is Innova Pharmacy healthcare platform?',
    answer: 'Innova Pharmacy is a comprehensive digital healthcare platform that provides various medical services including telemedicine consultations, prescription services, and home delivery of medications.',
    icon: <StethoscopeIcon className="w-5 h-5" data-id="element-5235" data-mp="1si1p4oe13u69" />
  }, {
    question: 'What services does Innova Pharmacy offer?',
    answer: 'We offer instant medical consultations, appointments with specialized doctors, prescription services with home delivery, regular health monitoring, and health insurance services.',
    icon: <ClipboardListIcon className="w-5 h-5" data-id="element-5236" data-mp="1nj6wkuq9er8y" />
  }, {
    question: 'Are online medical consultations confidential and secure?',
    answer: 'Yes, all consultations are protected with the highest security and privacy standards. We are committed to protecting your health data in accordance with HIPAA standards.',
    icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-5237" data-mp="1gdnuwh4hluku" />
  }, {
    question: 'How can I register with Innova Pharmacy?',
    answer: 'You can easily register through our website or mobile app using your phone number or email address. The process takes less than two minutes.',
    icon: <CalendarIcon className="w-5 h-5" data-id="element-5238" data-mp="is8dpurmmtno" />
  }, {
    question: 'Are medical consultations free?',
    answer: 'We provide a free initial consultation for all new users. After that, prices vary depending on the type of consultation and medical specialty.',
    icon: <StethoscopeIcon className="w-5 h-5" data-id="element-5239" data-mp="4y8rauhrw4gr" />
  }, {
    question: 'What is the subscription cost for telemedicine services?',
    answer: 'We offer monthly and annual subscription packages starting from SAR 99 per month, with special discounts for annual subscriptions.',
    icon: <ClipboardListIcon className="w-5 h-5" data-id="element-5240" data-mp="tov68aihnf8l" />
  }, {
    question: 'How can I get a medical consultation?',
    answer: 'After registration, you can choose the required specialty and book an immediate or scheduled appointment with the appropriate doctor through the platform.',
    icon: <PhoneIcon className="w-5 h-5" data-id="element-5241" data-mp="6qs7godsdva2" />
  }, {
    question: 'Can I have a medical consultation via mobile?',
    answer: 'Yes, our app is available on iOS and Android and provides all services including video and audio consultations.',
    icon: <MapPinIcon className="w-5 h-5" data-id="element-5242" data-mp="koyn0oevb8kx" />
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-gray-50 py-12" data-id="element-5243" data-mp="1r52a9354nv7y">
      <div className="container mx-auto px-4" data-id="element-5244" data-mp="1w455jvvb2n2q">
        <div className="text-center mb-10" data-id="element-5245" data-mp="1w2tzfpee138g">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-5246" data-mp="3gmfvc7bb3bde">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto" data-id="element-5247" data-mp="3boe4h07n27rd">
            Learn more about Innova Pharmacy and our healthcare services to
            understand how to use our platform easily and conveniently
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-6xl mx-auto mb-8" data-id="element-5248" data-mp="31vp533pd4kce">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all hover:shadow-md" data-id="element-5249" data-mp="2swbu26llbnpk" data-mpi={index}>
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-5250" data-mp="2iyp50rakufrv">
                <div className="flex items-center flex-1" data-id="element-5251" data-mp="h6ssbecoazvi">
                  <div className="text-[#0066CC] mr-3 flex-shrink-0" data-id="element-5252" data-mp="h57w7kapn8vj">
                    {faq.icon}
                  </div>
                  <span className="font-semibold text-gray-900 text-sm md:text-base" data-id="element-5253" data-mp="u73c80jzk456">
                    {faq.question}
                  </span>
                </div>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform flex-shrink-0 ml-3 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-5254" data-mp="f9kp12myhyzu" />
              </button>
              {openIndex === index && <div className="px-6 pb-4 text-left" data-id="element-5255" data-mp="b9ai9nrcb4jx">
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-5256" data-mp="ba24w92ylry2">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
        <div className="text-center" data-id="element-5257" data-mp="3jo0w6xezkp58">
          <button className="bg-gradient-to-r from-pink-400 to-pink-500 hover:from-pink-500 hover:to-pink-600 text-white font-bold py-4 px-12 rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:scale-105" data-id="element-5258" data-mp="3jp3lx20koljk">
            Contact Us
          </button>
        </div>
      </div>
    </div>;
}